/**
 * Internationalization module.
 *
 * Provides locale configuration, navigation helpers, and translation utilities.
 */

// Configuration
export {
  defaultLocale,
  getCountryFromLocale,
  getLanguageFromLocale,
  getRecaptchaLanguageFromLocale,
  getSupportedLanguages,
  isValidLocale,
  locales,
} from './config';
export type { Locale } from './config';
// Navigation
export {
  buildLocalizedPath,
  Link,
  redirect,
  stripLocaleFromPath,
  usePathname,
  useRouter,
} from './navigation';
